import { StatusBadge } from "@/features/invoices-table/cells/status-badge";
import { InvoiceSmbReviewStatus } from "@/lib/constants/invoiceStatus";
import { Check, Eye } from "lucide-react";
import { useTranslation } from "react-i18next";

export function SmbReviewStatusCell({ row }: { row: any }) {
  const { t } = useTranslation();
  const status = row.original.invoice.smbReviewStatus;

  return (
    <div className="pl-2">
      {status === InvoiceSmbReviewStatus.UNREVIEWED ? (
        <StatusBadge
          icon={Eye}
          iconColor="text-orange-600"
          textColor="text-orange-800"
          containerColor="bg-orange-100 border border-orange-200"
        >
          {t("smb_review_status.needs_review")}
        </StatusBadge>
      ) : (
        <StatusBadge
          icon={Check}
          iconColor="text-green-800"
          textColor="text-green-800"
          containerColor="bg-green-100 border border-green-200"
        >
          {t("smb_review_status.checked")}
        </StatusBadge>
      )}
    </div>
  );
}
